import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=b88bb0c0&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports